import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToCheckCross',
  standalone: true,
  pure: true,
})
export class BooleanToCheckCrossPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? '✅' : '❌';
  }
}
